export default [
    {
        id: 1,
        name_ca: 'Urbà',
        name_en: 'Urban',
        name_es: 'Urbano'
    },
    {
        id: 2,
        name_ca: 'Suburbà',
        name_en: 'Suburban',
        name_es: 'Suburbano'
    },
    {
        id: 3,
        name_ca: 'Rural',
        name_en: 'Rural',
        name_es: 'Rural'
    }
]



// WEBPACK FOOTER //
// ./src/options/territorial_features.js